export default __webpack_public_path__ + "static/media/cliniMACS-1.06bc068e.jpg";